var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m464.867 80.333h-259.824c-4.576 0-8.878-1.782-12.114-5.018l-29.377-29.377c-8.902-8.902-20.739-13.805-33.328-13.805h-83.09c-25.99 0-47.134 21.145-47.134 47.134v67.539c13.045-10.104 29.393-16.14 47.133-16.14h417.734c17.74 0 34.088 6.035 47.133 16.14v-19.339c0-26.076-21.104-47.134-47.133-47.134z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m464.867 160.667h-417.734c-26.071 0-47.133 21.1-47.133 47.133v224.933c0 26.071 21.101 47.133 47.133 47.133h417.733c26.075 0 47.133-21.105 47.133-47.133v-224.933c.001-26.075-21.103-47.133-47.132-47.133z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.0a8e1855a925a1afdcde766f7e41025e.svg";
export { ForwardRef as ReactComponent };